import {
  properties,
  structure,
  users,
  website,
  crm,
} from "../../../../admin/svgs/svgs";

export const adminDashboardRoutes = [
  {
    id: "1",
    name: "Properties",
    path: "properties",
    img: properties,
  },
  {
    id: "2",
    name: "Form Structure",
    path: "form-structure",
    img: structure,
  },
  {
    id: "3",
    name: "Users",
    path: "users",
    img: users,
  },
  {
    id: "4",
    name: "Web Configs",
    path: "web-configs",
    img: website,
  },
  {
    id: "5",
    name: "CRM",
    path: "crm",
    img: crm,
  },
];

export const dashboardRoutes = [
  {
    id: "1",
    name: "Properties",
    path: "properties",
    img: properties,
  },
  {
    id: "2",
    name: "Users",
    path: "users",
    img: users,
  },
  {
    id: "3",
    name: "CRM",
    path: "crm",
    img: crm,
  },
  // {
  //   id: "4",
  //   name: "Web Configs",
  //   path: "web-configs",
  //   img: website,
  // }
];
